import generateSettings from '../helpers/Settings';
import generateStyles from './styles';

export default (container = document) => {
  const modules = container.querySelectorAll('[data-cms-module-blockquote]');

  modules.forEach((module, i) => {
    const module_name = 'Blockquote';
    const settingsData = module.querySelector('[data-settings]');
    if (!settingsData) return;
    const settings = generateSettings(settingsData.innerHTML);
    if (!settings) return;

    const moduleWidth = `Section--${settings.module_width} Section--mobile-${settings['module_width--mobile']}`;

    const new_html = `
    <section id="Module-${module_name}--${i}" data-section-id="${module_name}--${i}" data-section-type="" class="CMS-Module Module-${module_name} Section ${moduleWidth}">
      <div class="Section__bg" style="background-image:url('${settings.background_texture}');">
        <div class="Section__container">
          <div class="Module-Blockquote__Content">${settings.content}</div>
        </div>
      </div>
    </section>
    ${generateStyles(settings, module_name, i)}
    `;

    module.innerHTML = new_html;
  });
};
